import { dayjs } from '../libs/day';

/**
 * @description Generates a Stay22 URL with the given parameters.
 * @param {Object} params - The parameters for the Stay22 URL.
 * @param {string} params.campaign - The campaign identifier.
 * @param {string} [params.address] - The address to search for.
 * @param {string} [params.checkin] - The check-in date in YYYY-MM-DD format.
 * @param {string} [params.checkout] - The check-out date in YYYY-MM-DD format.
 * @returns {string} The generated Stay22 URL.
 */
export const createStay22Url = (params: {
  campaign: string;
  address?: string;
  checkin?: string;
  checkout?: string;
  forceBrowser?: boolean;
}): string => {
  const { address, campaign, checkin, checkout, forceBrowser } = params;

  const baseUrl = 'https://www.stay22.com/allez/searchbar';
  const searchParams = new URLSearchParams({
    aid: 'tictactrip',
    campaign,
  });

  if (address) searchParams.append('address', address);
  if (checkin) searchParams.append('checkin', checkin);
  if (checkout) searchParams.append('checkout', checkout);

  if (forceBrowser) {
    searchParams.append('medium', 'undertab');
  }

  return `${baseUrl}?${searchParams.toString()}`;
};

export const createStay22EmbedUrl = (params: {
  campaign: string;
  address: string;
  checkin?: string;
  checkout?: string;
  birthdates?: string[];
}): string => {
  const { address, birthdates, campaign, checkin, checkout } = params;

  const baseUrl = 'https://www.stay22.com/embed/gm';
  const searchParams = new URLSearchParams({
    aid: 'tictactrip',
    campaign,
    address,
  });

  if (checkin) searchParams.append('checkin', checkin);
  if (checkout) searchParams.append('checkout', checkout);

  if (birthdates && birthdates.length > 0) {
    let adults = 0;
    let children = 0;
    const today = dayjs();

    birthdates.forEach((dateStr) => {
      const age = today.diff(dayjs(dateStr), 'year');

      if (age >= 13) {
        adults++;
      } else {
        children++;
      }
    });

    searchParams.append('adults', adults.toString());
    searchParams.append('children', children.toString());
  }

  return `${baseUrl}?${searchParams.toString()}`;
};
